export enum EGarageUtility {
  Electricity = 'electricity',
  Water = 'water',
  Heating = 'heating',
  ExtinguishingSystem = 'extinguishingSystem',
}
